function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M313.7,134.3c-8.3-8.3-21.8-8.3-30.2,0L176.9,240.9c-8.3,8.3-8.3,21.8,0,30.2l106.7,106.7c4.2,4.2,9.6,6.3,15.1,6.3 c5.5,0,10.9-2.1,15.1-6.3c8.3-8.3,8.3-21.8,0-30.2L222.2,256l91.6-91.6C322.1,156.1,322.1,142.6,313.7,134.3z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    className: "previous-icon",
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      "enableBackground": "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/previous.634f2ce1.svg";
export { SvgComponent as ReactComponent };